import React from "react";
import { Link } from "react-router-dom";

export default function BusinessSuccess() {
  return (
    <div
      style={{
        padding: "60px 20px",
        textAlign: "center",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <h1 style={{ color: "#2e7d32", fontSize: "2.5rem", marginBottom: "20px" }}>
        🎉 Your Business Listing is Live!
      </h1>

      <p style={{ fontSize: "1.2rem", marginBottom: "40px" }}>
        Your lawn mowing business listing has been successfully posted and 
        activated on Client Exchange. Buyers can now find and contact you.
      </p>

      <Link
        to="/lawn-mowing/business"
        style={{
          backgroundColor: "#2e7d32",
          color: "white",
          padding: "12px 25px",
          borderRadius: "8px",
          textDecoration: "none",
          fontWeight: "bold",
          fontSize: "1.1rem"
        }}
      >
        View My Business Listings
      </Link>

      <br /><br />

      <Link
        to="/dashboard"
        style={{
          fontSize: "1rem",
          textDecoration: "underline",
          color: "#333",
        }}
      >
        Go to Dashboard
      </Link>
    </div>
  );
}

